import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {App} from './App';
import './styles.css';
import './owner-v3.css';
import '../../contracts/morefun-brand-r31.css';
import './owner-brand-r31.css';

const root=document.getElementById('root');
if(!root)throw new Error('MFK_OWNER_ROOT_REQUIRED');
createRoot(root).render(<StrictMode><App/></StrictMode>);
